import { render } from "./MixedChatDemo.vue?vue&type=template&id=108ce399&scoped=true"
import script from "./MixedChatDemo.vue?vue&type=script&lang=ts"
export * from "./MixedChatDemo.vue?vue&type=script&lang=ts"

import "./MixedChatDemo.vue?vue&type=style&index=0&id=108ce399&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-108ce399"

export default script